import { type ValidationProps, type ValidationResponse } from "./contract";

const TRANSLATION_PATH = "auth.form.email.error";

const isValidEmail = (email: string): boolean =>
  /[a-zA-Z0-9!#$%&‘*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&‘*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/.test(
    email,
  );

const validations: ValidationProps[] = [{ key: "format", test: isValidEmail }];

export const validateEmail = (email: string): ValidationResponse =>
  validations.reduce(
    (acc: ValidationResponse, validation: ValidationProps) => {
      const { key, test } = validation;
      const currentValidation = test(email);

      if (!currentValidation) {
        acc.errors.push(`${TRANSLATION_PATH}.${key}`);
      }

      return {
        errors: acc.errors,
        value: !acc.errors.length,
      };
    },
    { errors: [], value: true },
  );
